import { BASE_PATH } from '../../shared/types';
import { AppIcon } from './AppIcon';

export function Brand() {
  return <a class="app-brand" href={`${BASE_PATH}/`}><AppIcon name="forms" />Gathered In Forms</a>;
}
